import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { memo } from "react";
import { PLAN_TYPE_NAMES } from "../../../consts/planTypes";

const ROUTE_DISPLAY_LIMIT = 20;

const useStyles = makeStyles({
  intro: {
    marginBottom: "16px",
  },
  dayName: {
    fontWeight: 700,
  },
  planBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: "16px",
  },
  planName: {
    fontWeight: 700,
  },
  planTypeSections: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  planTypeSection: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  listItem: {
    fontSize: "12px",
    lineHeight: "14px",
  },
  additionalItems: {
    color: "rgba(0, 0, 0, 0.5)",
  },
  footer: {
    marginTop: "12px",
  },
});

const RouteList = ({ routes = [], styles }) => {
  const shownRoutes = routes.slice(0, ROUTE_DISPLAY_LIMIT);
  const hiddenCount = routes.length - shownRoutes.length;

  return (
    <>
      {!!shownRoutes.length && (
        <div className={styles.listItem}>{shownRoutes.join(", ")}</div>
      )}
      {hiddenCount > 0 && (
        <div className={`${styles.listItem} ${styles.additionalItems}`}>
          +{hiddenCount} Other Routes
        </div>
      )}
    </>
  );
};

export const WeekendRouteOverlapModalContent = memo(
  ({ isCopy, targetDayName, conflictingPlans = [] }) => {
    const styles = useStyles();

    return (
      <>
        <Typography className={styles.intro}>
          {isCopy ? (
            <>
              Copy to <span className={styles.dayName}>{targetDayName}</span>{" "}
              contains routes that are also present in the following plan(s):
            </>
          ) : (
            "This plan contains routes that are also present in the following plan(s):"
          )}
        </Typography>

        {conflictingPlans.map(
          ({ templateId, templateName, conflictRoutes, conflictSections }) => (
            <div key={templateId} className={styles.planBlock}>
              <div className={styles.planName}>{templateName}</div>
              {conflictSections?.length ? (
                <div className={styles.planTypeSections}>
                  {conflictSections.map(
                    ({ planType, conflictRoutes: routes }) => (
                      <div
                        key={`${templateId}-${planType}`}
                        className={styles.planTypeSection}
                      >
                        <div>{PLAN_TYPE_NAMES[planType] ?? planType}</div>
                        <RouteList routes={routes} styles={styles} />
                      </div>
                    )
                  )}
                </div>
              ) : (
                <RouteList routes={conflictRoutes} styles={styles} />
              )}
            </div>
          )
        )}

        <Typography className={styles.footer}>
          {isCopy
            ? "Continue to copy to this day, or cancel to leave it unchanged."
            : "Continue to save this plan, or cancel to leave it unchanged."}
        </Typography>
      </>
    );
  }
);
